import Vue from "vue";
import Router from "vue-router";
import Hello from "@/components/Hello";
// import HomePage from "@/components/pages/home";
const HomePage = () => import("@/components/pages/home");

// import movieDetails from "@/components/pages/movieDetails";
const movieDetails = () => import("@/components/pages/movieDetails");

// import SNcheckout from "@/components/pages/SNcheckout";
const SNcheckout = () => import("@/components/pages/SNcheckout");

// import events from "@/components/pages/events";
const events = () => import("@/components/pages/events");

// import eventDetails from "@/components/pages/eventDetails";
const eventDetails = () => import("@/components/pages/eventDetails");

import movieListing from "@/components/pages/movieListing";
import cinemaDetails from "@/components/pages/cinemaDetails";
import cinema from "@/components/pages/cinema";
// import movies from "@/components/pages/movies";
const movies = () => import("@/components/pages/movies");

// import cinemaListing from "@/components/pages/cinemaListing";
const cinemaListing = () => import("@/components/pages/cinemaListing");

import checkout from "@/components/pages/checkout";
import CinemaNameListing from "@/components/pages/cinemaNameListing";
// import support from "@/components/pages/support";
const support = () => import("@/components/pages/support");

// import finalTicket from "@/components/pages/finalTicket";
const finalTicket = () => import("@/components/pages/finalTicket");

// import processPayment from "@/components/pages/processPayment";
const processPayment = () => import("@/components/pages/processPayment");

// import receiptPage from "@/components/pages/receiptPage";
const receiptPage = () => import("@/components/pages/receiptPage");

// import failedPayment from "@/components/pages/failedPayment";
const failedPayment = () => import("@/components/pages/failedPayment");

// import retriedPayment from "@/components/pages/retriedPayment";
const retriedPayment = () => import("@/components/pages/retriedPayment");

import offers from "@/components/pages/offers";
import promotion from "@/components/pages/promotion";
// import error404 from "@/components/pages/error404";
const error404 = () => import("@/components/pages/error404");

// import failedPage from "@/components/pages/failed-page";
const failedPage = () => import("@/components/pages/failed-page");

// import cancelPage from "@/components/pages/cancel-page";
const cancelPage = () => import("@/components/pages/cancel-page");

// import completedPage from "@/components/pages/completed-page";
const completedPage = () => import("@/components/pages/completed-page");

// import tnc from "@/components/pages/tnc";
const tnc = () => import("@/components/pages/tnc");

// import faq from "@/components/pages/faq";
const faq = () => import("@/components/pages/faq");

// import privacy from "@/components/pages/privacy";
const privacy = () => import("@/components/pages/privacy");

// import contact from "@/components/pages/contact";
const contact = () => import("@/components/pages/contact");

import pricing from "@/components/pages/pricing";
// import terms from "@/components/pages/terms";
const terms = () => import("@/components/pages/terms");

import showtime from "@/components/pages/show";
// import userProfile from '@/components/pages/userProfile'
import ticket from "@/components/pages/ticket";
// import aboutUs from "@/components/pages/aboutUs";
const aboutUs = () => import("@/components/pages/aboutUs");

// import paymentCheck from "@/components/pages/paymentCheck";
const paymentCheck = () => import("@/components/pages/paymentCheck");

import underConstruction from "@/components/pages/underConstruction";
// import sitemap from "@/components/pages/sitemap";
const sitemap = () => import("@/components/pages/sitemap");

import mobilePayment from "@/components/pages/mobilePayment";
import referAFriend from "@/components/pages/referAFriend";
import checkoutVoucher from "@/components/pages/CheckoutVoucher";
// import confirmVoucher from "@/components/pages/ConfirmVoucher";
const confirmVoucher = () => import("@/components/pages/confirmVoucher");

import gtmTest from "@/components/pages/gtmTest";

// import userProfile from "@/components/pages/userProfile3";
const userProfile = () => import("@/components/pages/userProfile3");

// import userBookings from "@/components/pages/userBookings";
const userBookings = () => import("@/components/pages/userBookings");

// import userVouchers from "@/components/pages/userVouchers";
const userVouchers = () => import("@/components/pages/userVouchers");

// import paymentSummary from "@/components/pages/paymentSummary";
const paymentSummary = () => import("@/components/pages/paymentSummary");
const event_seat_layout = () => import("@/components/pages/event_seat_layout");

// import processPayment1 from "@/components/pages/processPayment1";
const processPayment1 = () => import("@/components/pages/processPayment1");

import { CountryService } from "@/services/storage.service";
// const UserDetails = () => import('./views/UserDetails.vue')

Vue.use(Router);
let country = CountryService.getCountry();
let countryName =
  country && country["CountryName"].toLowerCase()
    ? country["CountryName"].toLowerCase()
    : "uae";
export default new Router({
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomePage
      //component: underConstruction
    },
    // {
    //   path: "/referral/:code",
    //   name: "Referral",
    //   component: HomePage
    // },
    // {
    //   path: "/tt",
    //   name: "tt",
    //   component: ticket
    // },
    {
      path: "/tnc",
      name: "tnc",
      component: tnc
    },
    {
      path: "/faq",
      name: "faq",
      component: faq
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy
    },
    {
      path: "/contact",
      name: "contact",
      component: contact
    },
    {
      path: "/terms",
      name: "terms",
      component: terms
    },
    // {
    //   path: "/pricing",
    //   name: "pricing",
    //   component: pricing
    // },
    // {
    //   path: "/offers",
    //   name: "offers",
    //   component: offers
    // },
    // {
    //   path: "/promotions",
    //   name: "promotion",
    //   component: promotion
    // },
    {
      path: "/movie/:movieID/:cinemaID",
      name: "movie",
      component: movieDetails,
      props: true
    },
    {
      path: "/movie/:CountryID/:LanguageId/:movieID",
      name: "movie",
      component: movieDetails,
      props: true
    },
    // {
    //   path: "/showtime",
    //   name: "show",
    //   component: showtime
    // },
    // {
    //   path: '/testpage',
    //   name: 'testpage',
    //   component: testpage
    // },

    // {
    //   path: "/underconstruction",
    //   name: "underconstruction",
    //   component: underConstruction
    // },
    {
      path: "/event-seat-layout/:scheduleID",
      name: "event_seat_layout",
      component: event_seat_layout
    },
    {
      path: "/cinemas",
      name: "cinemas",
      component: cinemaListing
    },
    {
      path: "/support",
      name: "support",
      component: support
    },
    {
      path: "/movies",
      name: "movies",
      component: movies
    },
    {
      path: "/movieDetails",
      name: "movieDetails",
      component: movieDetails
    },
    {
      path: "/events",
      name: "events",
      component: events
    },
    {
      path: "/event-details/:eventID/",
      name: "eventDetails",
      component: eventDetails
    },
    {
      path: "/process-payment/:paymentID",
      name: "processPayment",
      component: processPayment1
    },
    {
      path: "/payment-summary/:reseverID",
      name: "paymentSummary",
      component: paymentSummary,
      props: true
    },
    {
      path: "/payment-cancelled/:paymentID",
      name: "paymentSummary",
      component: cancelPage
    },
    {
      path: "/payment-failed/:paymentID",
      name: "paymentSummary",
      component: failedPage
    },
    {
      path: "/payment-completed/:paymentID",
      name: "paymentSummary",
      component: completedPage
    },
    {
      path: "/failedPayment",
      name: "failedPayment",
      component: failedPayment
    },
    {
      path: "/paymentRetried/:type/:typeID",
      name: "retriedPayment",
      component: retriedPayment
    },
    // {
    //   path: "/cinemaDetails/:cinemaId",
    //   name: "cinemaDetails",
    //   component: cinemaDetails
    // },
    // {
    //   path: "/cinemas/:cinemaId",
    //   name: "cinema",
    //   component: cinema
    // },
    // {
    //   //path: '/cinemaNameListing/:cinemaName',
    //   path: "/cinema/:cinemaName",
    //   name: "cinemaNameListing",
    //   component: CinemaNameListing
    // },
    {
      path: "/processPayment/:reserveId/:token",
      name: "processPayment",
      component: processPayment
    },
    {
      path: "/PaymentComplete/*",
      name: "receiptPage",
      component: receiptPage
    },
    {
      path: "/paymentCheck",
      name: "paymentcheck",
      component: paymentCheck
    },
    {
      path: "/confirmBooking/:bookingId",
      name: "confirmBooking",
      component: finalTicket
    },
    {
      path: "/confirmVoucher/:bookingId",
      name: "confirmVoucher",
      component: confirmVoucher
    },
    // {
    //   path: "/mobilePayment",
    //   name: "mobilePayment",
    //   component: mobilePayment
    // },
    // {
    //   path: "/angamovieoffers",
    //   name: "checkoutVoucher",
    //   component: checkoutVoucher
    // },
    {
      path: "/checkout/:movieID/:scheduleID/:seatLayout",
      name: "checkout",
      component: SNcheckout,
      props: true
    },
    {
      path: "/aboutus",
      name: "About",
      component: aboutUs
    },
    // {
    //   path: "/refer",
    //   name: "referAFriend",
    //   component: referAFriend
    // },
    {
      path: "*",
      name: "error404",
      component: error404
    },
    {
      path: "/user-profile",
      name: "userProfile",
      component: userProfile
    },
    {
      path: "/my-bookings",
      name: "userBookings",
      component: userBookings
    },
    {
      path: "/my-vouchers",
      name: "userVouchers",
      component: userVouchers
    },
    // {
    //   path: "/gtm-test/token=92217357359833045535",
    //   name: "gtmTest",
    //   component: gtmTest
    // },
    {
      path: "/sitemap",
      name: "sitemap",
      component: sitemap
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js